






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";

export default Vue.extend({
  data() {
    return {
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: "Quản lý loại kênh KOC",
          urlEnabled: true,
          search: {},
          displayFields: {
            name: {
              text: "Tên",
              sortable: true,
            },
            isDefault: {
              text: "Mặc định",
              sortable: true,
              options: {
                boolean: true,
              },
            },
            createdTime: {
              text: "Ngày tạo",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {},
          },
          template: {
            itemActionButtons: {
              edit: {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
              },
              delete: {},
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("creatorChannelTypes", "findAll", options);
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("creatorChannelTypes", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "creatorChannelTypes",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("creatorChannelTypes", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Tên",
                  required: true,
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
              isDefault: {
                type: "boolean",
                attrs: {
                  label: "Mặc định",
                },
              },
            },
            insertForm: {
              content: {
                fieldNames: ["name", "description", "isDefault"],
              },
            },
            editForm: {
              content: {
                fieldNames: ["name", "description", "isDefault"],
              },
            },
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      },
    };
  },
});
